import React from "react";
import * as facilityAccountingReferenceApi from "api/rpc/2024-04/facilityAdmin/facility/accounting";
import AccountingReferenceEdit from "pages/secure/shared/settings/accountingReferences/AccountingReferenceEdit";

export default function FacilityAccountingReferenceEdit() {
  return <AccountingReferenceEdit api={facilityAccountingReferenceApi} />;
}
